import React, { useState } from "react";
import { StyleSheet, View, FlatList } from "react-native";

import { hasItems, isWeb } from "../../../../helpers/utils";
import AppTheme from "../../AppTheme";
import Icons from "../icons/index";
import ManaDropdownItem from "./ManaDropdownItem";

export default function ManaDropdown({
  options = [],
  onPickerValueChanged = () => {},
  selectedValue,
  field,
  hideIcon = false,
  isDisabled = false,
  expand = false,
  style = {},
}) {
  const [isCollapsed, setIsCollapsed] = useState(true);
  const hasMultipleOptions =
    !isDisabled && hasItems(options) && options.length > 1;

  const toggleIcon = () => {
    if (isDisabled || !hasMultipleOptions) return;

    setIsCollapsed((prev) => !prev);
  };

  const onItemSelected = (item) => {
    onPickerValueChanged(item);
    setIsCollapsed(true);
  };

  return (
    <View
      style={[styles.container, expand && { minHeight: 34, height: "auto" }]}
    >
      <View style={[styles.content, !expand && styles.abso, style]}>
        <ManaDropdownItem
          field={field}
          item={selectedValue}
          onItemSelected={toggleIcon}
          hideIcon={hideIcon}
          style={
            (!isCollapsed && styles.borderBottom,
            isDisabled && {
              backgroundColor: "#F3F2F1",
              color: AppTheme.almostBlack,
              borderRadius: 6,
            })
          }
        />

        {hasMultipleOptions ? (
          <Icons.ArrowDropdown
            onPress={toggleIcon}
            style={styles.arrow}
            isOpen={!isCollapsed}
          />
        ) : null}

        {!isCollapsed ? (
          <FlatList
            data={options}
            keyExtractor={(item) => item.name}
            renderItem={({ item }) => (
              <ManaDropdownItem
                item={item}
                onItemSelected={onItemSelected}
                field={field}
                hideIcon={hideIcon}
                isListItem
                isSelected={
                  selectedValue && item[field] == selectedValue[field]
                }
              />
            )}
          />
        ) : null}
      </View>
    </View>
  );
}

const styles = StyleSheet.create({
  container: {
    position: "relative",
    height: 34,
    color: "#000",
    width: "auto",
  },
  content: {
    backgroundColor: "#FFF",
    zIndex: 1000,
    borderColor: "#000",
    borderWidth: 1,
    borderRadius: 4,
  },
  abso: {
    position: "absolute",
    left: 0,
    right: 0,
    top: 0,
    maxHeight: 140,
  },
  borderBottom: {
    borderBottomWidth: 1,
    borderBottomColor: "rgba(45, 49, 66, 0.3)",
  },
  arrow: {
    position: "absolute",
    right: isWeb ? 10 : 6,
    top: 12,
    zIndex: 2,
  },
});
